class NoticeData {
    // 横幅公告
    private _bannerItems: Array<any> = []
    // 弹窗公告
    private _popUpItems: Array<any> = []

    setData (data: Array<any>) {
        this._bannerItems = []
        this._popUpItems = []
        
        data.forEach(item => {
            if (item.messageType === 0) {
                this._bannerItems.push(item)
            }else if (item.messageType === 1) {
                this._popUpItems.push(item)
            }
        });
    }

    getBannerItems () {
        return this._bannerItems.slice()
    }

    getPopUpItems () {
        return this._popUpItems.slice()
    }
}

export default new NoticeData()